import { useEffect, useState } from "react";
import { X, ChevronRight, Sparkles } from "lucide-react";
import api from "../api";
import { useUnit } from "../context/UnitContext";

export const WrappedModal = ({ onClose }) => {
  const { unit, dw } = useUnit();
  const [data, setData] = useState(null);
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    api.get("/wrapped").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;

  const slides = data.empty
    ? [{ label: `RÉCAP ${data.year}`, big: "—", sub: "Aucune séance cette année… encore. Va soulever !" }]
    : [
        { label: `TON ANNÉE ${data.year}`, big: `${Math.round(dw(data.volume_total)).toLocaleString("fr-CA")}`, unit,
          sub: `${unit} de volume total soulevé. Une montagne. 🏔️` },
        { label: "ASSIDUITÉ", big: `${data.nb_seances}`, unit: "séances",
          sub: `${data.nb_series} séries loggées · meilleur streak : ${data.max_streak} semaine${data.max_streak > 1 ? "s" : ""} de suite 🔥` },
        { label: "TON EXERCICE FÉTICHE", big: data.top_exercice, small: true,
          sub: `${Math.round(dw(data.top_exercice_volume)).toLocaleString("fr-CA")} ${unit} de volume rien que là-dessus` },
        { label: "TA PLUS GROSSE BARRE", big: `${dw(data.poids_max)} ${unit}`,
          sub: `sur ${data.poids_max_exercice} — et ${data.nb_prs} record${data.nb_prs > 1 ? "s" : ""} battus cette année 🏆` },
        { label: "PALMARÈS", big: data.rank ? `#${data.rank}` : "—",
          sub: `au podium sur ${data.nb_membres} membres · ${data.defis} défi${data.defis > 1 ? "s" : ""} mensuel${data.defis > 1 ? "s" : ""} + ${data.duels} duel${data.duels > 1 ? "s" : ""} gagnés · Meilleur mois : ${data.best_month} (${Math.round(dw(data.best_month_volume)).toLocaleString("fr-CA")} ${unit})` },
      ];

  const s = slides[slide];
  const last = slide === slides.length - 1;

  return (
    <div data-testid="wrapped-modal" className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col"
      onClick={() => !last && setSlide(slide + 1)}>
      <div className="max-w-md mx-auto w-full flex-1 flex flex-col p-6">
        <div className="flex items-center justify-between">
          <p className="font-display text-2xl text-white flex items-center gap-2">
            <Sparkles size={18} className="text-[#FF3B30]" /> RÉCAP {data.year}
          </p>
          <button data-testid="wrapped-close-button" onClick={(e) => { e.stopPropagation(); onClose(); }}
            className="text-[#B0B0B4] hover:text-white p-2 transition-colors" aria-label="Fermer">
            <X size={22} />
          </button>
        </div>
        <div className="flex gap-1 mt-3">
          {slides.map((sl, i) => (
            <div key={sl.label} className={`h-[3px] flex-1 ${i <= slide ? "bg-[#FF3B30]" : "bg-[#14141A]"}`} />
          ))}
        </div>
        <div key={slide} className="flex-1 flex flex-col items-center justify-center text-center px-4 animate-[splashPop_.5s_ease-out]">
          <p className="text-[#FF3B30] text-xs uppercase tracking-[0.3em]">{s.label}</p>
          <p data-testid="wrapped-big-stat"
            className={`font-display text-white mt-4 leading-none ${s.small ? "text-5xl" : "text-8xl"}`}>
            {s.big}{s.unit && <span className="text-3xl text-[#B0B0B4] ml-2">{s.unit}</span>}
          </p>
          <p className="text-[#ccc] text-sm mt-6 max-w-xs">{s.sub}</p>
        </div>
        <button data-testid="wrapped-next-button"
          onClick={(e) => { e.stopPropagation(); last ? onClose() : setSlide(slide + 1); }}
          className="h-12 w-full bg-[#FF3B30] text-white font-display text-xl tracking-wide hover:bg-[#e0332a] transition-colors flex items-center justify-center gap-1 mb-4">
          {last ? "FERMER" : <>SUIVANT <ChevronRight size={18} /></>}
        </button>
      </div>
    </div>
  );
};
